import { useNavigate } from "react-router-dom";
import ButtonCustom from "../../../component/button/buttonCustom";
import InputCheckbox from "../../../component/input/inputCheckbox";
import InputPasswordField from "../../../component/input/inputPasswordField";
import InputUsernameField from "../../../component/input/inputUsernameField";
import Typography from '@mui/material/Typography';
import { useState } from "react";
import LoginApi from "../../../api/auth/auth.api";
import { STORAGE_KEY } from "../../../utils/enum";
import { logout } from "../../../utils/app.utils";
import { swalError } from "../../../component/notification/swal";
import { useTranslation } from "react-i18next";
const initStateErrorMessage = {
  EMAIL: "",
  PASSWORD: "",
};
export default function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
  const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);


  const getUserProfile = async (accessToken: string) => {
    await LoginApi.getUser(accessToken)
      .then(async (res: any) => {
        if (res.data.success) {
          // localStorage.setItem(STORAGE_KEY.PERMISSION, JSON.stringify(res.data.result.Permissions))
          // localStorage.setItem(STORAGE_KEY.PROFILE, JSON.stringify(res.data.result))
          window.location.href = '/'
        } else {
          logout()
        }
      }).catch(() => logout());
  }

  const submit = async () => {
    if (!email)
      return setErrorMessage({
        ...errorMessage,
        ...{ EMAIL: t('LOGIN.MESSAGE.EMAIL') },
      });
    if (!password)
      return setErrorMessage({
        ...errorMessage,
        ...{ PASSWORD: t('LOGIN.MESSAGE.PASSWORD') },
      });
    setLoading(true);

    await LoginApi.login(email, password)
      .then(async ({ data }) => {
        if (data.result.accessToken) {
          if (data.result.requireChangePassword) {
            return navigate('/confim-password', { state: { atoken: data.result.accessToken } })
          }
          localStorage.setItem(STORAGE_KEY.TOKEN, data.result.accessToken)
          localStorage.setItem(STORAGE_KEY.RTOKEN, data.result.refreshToken)
          getUserProfile(data.result.accessToken)
          setLoading(false);
        } else {
          setLoading(false);
          swalError(data.description);
        }
      })
      .catch((e) => {
        setLoading(false);
        swalError(e.response.data.description || e.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      })
  };

  return (
    <>

      <div style={{
        width: "100%",
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <InputUsernameField
          heading={t('LOGIN.INPUT.EMAIL')}
          onchange={(event) => {
            setEmail(event.target.value);
            clearErrorMessage();
          }}

          onkeyup={(event) =>
            event.key === "Enter" && submit()
          }
          helperText={
            errorMessage.EMAIL || ''
          } />
        <InputPasswordField
          heading={t('LOGIN.INPUT.PASSWORD')}
          onchange={(event) => {
            setPassword(event.target.value);
            clearErrorMessage();
          }}

          onkeyup={(event) =>
            event.key === "Enter" && submit()
          }
          helperText={
            errorMessage.PASSWORD || ''
          } />
        <div style={{
          width: "100%",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <InputCheckbox label={t('LOGIN.INPUT.REMEMBER_ME')} />
          <Typography onClick={() => navigate('/forgot-password')} sx={{
            color: 'var(--text-icons-light-base-second, #858C95)',
            cursor: 'pointer'
          }}>{t('LOGIN.FORGOT_PASSWORD') + ' ?'}</Typography>
        </div>
      </div >
      <ButtonCustom
        type="submit"
        onClick={() => {
          submit()
        }}
        disabled={loading}
        textButton={t('LOGIN.BUTTON.SUBMMIT')}
        btnStyle={{
          fontSize: "16px",
          width: "100%",
        }}
        style={{ width: "100%", }}
      />
    </>
  )
}
